import { CheckIcon, PencilLine } from "lucide-react";

const targets = [
  {
    label: "Target Industry",
    value: "Information Technology",
  },
  {
    label: "Target Seniority",
    value: "Manager",
  },
  {
    label: "Preferred Location",
    value: "London, United Kingdom",
  },
];

const careerProgression = [
  {
    label: "Current Role",
    value: "Cyber Security Analyst",
  },
  {
    label: "Next step",
    value: "Senior Security Analyst",
  },
  {
    label: "Target role",
    value: "Cyber Security Manager",
  },
];

const keyAreas = [
  {
    label: "Leadership",
    value: "Lead and mentor high-performing security teams.",
  },
  {
    label: "Security Strategy",
    value: "Develop and implement strategies to reduce business risk.",
  },
  {
    label: "Risk Management",
    value: "Identify, assess and manage cyber risks effectively.",
  },
  {
    label: "Stakeholder Management",
    value: "Collaborate with stakeholders across",
  },
  //   {
  //     label: "Continuous growth",
  //     value: "Stay current with emerging threats and technologies.",
  //   },
];

const matchInsights = [
  {
    label: "Relevant experience",
    desc: "Your background aligns well with this role level.",
  },
  {
    label: "In-demand skils",
    desc: "You have skills highly valued in target roles.",
  },
  {
    label: "Clear progression",
    desc: "Your career path shows consistent growth.",
  },
  {
    label: "Location alignment",
    desc: "Your preferred location has strong opportunities.",
  },
];

const AspirationPage3 = () => {
  return (
    <div className="flex flex-col flex-1 rounded-md gap-5 min-h-0 overflow-y-scroll no-scrollbar">
      {/* Profile container */}
      <div className="flex rounded-xl bg-white w-full p-6 border justify-between">
        <div className="flex items-center gap-5">
          <div className="rounded-full bg-light-grey h-24 w-24"></div>
          <div className="flex flex-col gap-1">
            <span className="uppercase font-bold text-3xl text-slate-800">
              Alexander morgan
            </span>
            <span className="font-medium text-light-black">Aspirations</span>
            <span className="text-xs font-medium text-light-black">
              London, United Kingdom
            </span>
          </div>
        </div>

        <div className="flex flex-col items-end gap-5">
          <span className="italic text-xs">Last updated: October 2025</span>
          <button className="flex items-center gap-2 rounded-md border py-2 px-3">
            <PencilLine size={16} color="#334154" />
            <span className="text-slate-800 font-bold text-xs">
              Edit Profile
            </span>
          </button>
        </div>
      </div>
      {/* Main body  */}
      <div className="flex w-full gap-5">
        {/* Cols 1 */}
        <div className="flex flex-col gap-5 flex-1">
          {/* Row 1 */}
          <div className="flex flex-col border rounded-xl bg-white p-6 gap-3">
            <span className="uppercase text-xs font-bold text-slate-600">
              My target role
            </span>
            <span className="text-slate-800 text-3xl font-bold">
              Cyber Security Manager
            </span>
            <div className="border-t flex justify-between pt-5 mt-2">
              {targets?.map((target) => {
                return (
                  <div className="flex items-center gap-2.5">
                    <div className="h-11 w-11 rounded-full border bg-gray-100"></div>
                    <div className="flex flex-col gap-1">
                      <span className="text-xs font-bold text-gray-600">
                        {target?.label}
                      </span>
                      <span className="text-xs font-medium text-slate-800">
                        {target?.value}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          {/* Row 2 */}
          <div className="flex flex-col border rounded-xl bg-white p-6 gap-7">
            <div className="flex flex-col gap-1">
              <span className="uppercase text-xs font-bold text-slate-600">
                Career Progression
              </span>
              <span className="font-medium text-light-black text-xs">
                Clear, matchable career path based on current experience and
                target role.
              </span>
            </div>
            <div className="flex justify-between">
              {careerProgression?.map((career) => {
                return (
                  <div className="flex items-center gap-2.5">
                    <div className="h-11 w-11 rounded-full border bg-gray-100"></div>
                    <div className="flex flex-col gap-1">
                      <span className="text-xs font-bold text-gray-600">
                        {career?.label}
                      </span>
                      <span className="text-xs font-medium text-slate-800">
                        {career?.value}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="flex items-center flex-wrap gap-1 bg-gray-50 py-2 px-4 rounded-md border">
              <span className="text-xs font-bold w-max">You're on track.</span>
              <span className="text-xs font-medium text-light-black">
                Continue building leadership and security strategy skills to
                reach your goal.
              </span>
            </div>
          </div>
          {/* Row 3 */}
          <div className="flex flex-col border rounded-xl bg-white p-6 gap-5">
            <span className="uppercase text-xs font-bold text-slate-600">
              key areas of focus
            </span>

            <div className="flex justify-between gap-4">
              {keyAreas?.map((keyArea) => {
                return (
                  <div className="flex flex-col p-4 gap-2.5 bg-white border rounded-xl">
                    <div className="h-11 w-11 rounded-full border bg-gray-100"></div>
                    <div className="flex flex-col gap-1">
                      <span className="text-xs font-bold text-slate-800">
                        {keyArea?.label}
                      </span>
                      <span className="text-xss font-medium text-light-black">
                        {keyArea?.value}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        {/* Cols 2 */}
        <div className="flex flex-col gap-5 w-[28%] bg-white p-4">
          {/* Container 1 */}
          <div className="flex flex-col border rounded-xl flex-1 p-5 gap-4 h-max">
            <div className="flex items-center justify-between">
              <span className="uppercase font-bold text-xs text-slate-800">
                Profile status
              </span>
              <div className="bg-green-100 text-green-800 text-xs font-bold px-2 py-1 rounded-full">
                Active
              </div>
            </div>
            <div className="w-full h-px bg-gray-200" />
            <span className="font-semibold text-light-black text-xss leading-4">
              This profile is actively matched with relevant job opportunities.
            </span>
            {/* Match strength */}
            <div className="flex flex-col gap-1.5 my-2">
              <span className="font-bold uppercase text-xs text-slate-800">
                match strength
              </span>
              <span className="font-bold text-4xl text-slate-800">92%</span>
              <div className="rounded-full overflow-hidden h-2 w-full bg-gray-200">
                <div className="bg-slate-800 h-full w-[92%]" />
              </div>
            </div>
            {/* Excellent match */}
            <div className="flex flex-col gap-2">
              <span className="font-bold text-sm text-slate-800">
                Excellent Match
              </span>
              <span className="text-xss font-semibold leading-4 text-light-black">
                Your experience and skills strongly align with your career
                aspirations.
              </span>
              <span className="font-bold text-sm text-slate-800">
                What does this mean?
              </span>
            </div>
          </div>
          {/* Container 2 */}
          <div className="flex flex-col border rounded-xl flex-1 p-5 gap-2 h-max">
            <span className="uppercase font-bold text-xs text-slate-800">
              Match insights
            </span>

            <div className="flex flex-col">
              {matchInsights?.map((insight, insightIndex) => {
                return (
                  <div
                    className={`flex gap-4 py-3 ${insightIndex !== 0 ? "border-t" : ""}`}
                  >
                    <CheckIcon size={17} />
                    <div className="flex flex-col gap-1">
                      <span className="text-xs font-bold text-slate-800">
                        {insight?.label}
                      </span>
                      <span className="text-xss font-medium text-light-black">
                        {insight?.desc}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>

            <span className="font-bold text-xs text-slate-800">
              View full match insights
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AspirationPage3;
